import React, { useState, useEffect } from 'react'
import axios from 'axios';

import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/PopupDatasheet.css'
import './new_pages.css'
import { setDefaultForEmptyNumberFields } from '../utils/functions';

function ContactingrecipeNew ({ 
  closeNewPopup, 
  fields, 
  sortedMachineConfigurationOptions, 
  sortedYarnOptions,
  sortedBasicYarnOptions, 
  sortedContactingmethodOptions, 
  sortedInstitutionOptions, 
  fetchContactingrecipeAll, 
  sortedGlueOptions, 
  sortedSolderingagentOptions, 
  sortedFluxOptions, 
  sortedCrimpshapeOptions, 
  sortedKnottypeOptions, 
  sortedEmbroiderypatternOptions, 
  sortedGlueTemperatureUnitOptions, 
  sortedSolderTemperatureUnitOptions,
  fetchMachineConfigurationOptions, 
  fetchYarnOptions, 
  fetchBasicYarnOptions, 
  copiedData, 
  newSaveID, 
  formatTimestampNow, 
  fieldsContactingmethod, 
  setFieldsContactingmethod, 
  fieldConfigurations,
  convertCommaToDotForFloatFields, 
  handleFocus, 
  handleBlur, 
  validateField, 
  setErrorMessage,
  setShowErrorModal }) {

    const id_institution = window.localStorage.getItem('id_institution');
    const id_role = window.localStorage.getItem('id_role');

    const access_token = window.localStorage.getItem('access_token');
                     
    const [post, setPost] = useState({
      id_contactingrecipe: '',
      name: '',
      institution_name: '',
      machine_configuration_name: '',
      product: '',
      yarn_1_name: '',
      yarn_2_name: '',
      contactingmethod_name: '',
      prediction: '',
      others: '',
      all_can_read: false, // checkbox mit boolean-Wert initialisieren
      timestamp: '',

      glue_name: '',
      glue_own: '',
      glue_temperature: '',
      unit_glue_temperature_name: '',
      bonding_duration: '',
      quantity: '',
      curing: '',
      pressure: '',
      bonding_length: '',
      
      soldering_agent_name: '',
      soldering_agent_own: '',
      solder_temperature: '',
      solder_duration: '',
      unit_solder_temperature_name: '',
      flux_name: '',
      flux_own: '',
      solder_length: '',
      
      crimp_power: '',
      crimp_length: '',
      diameter: '',
      crimpshape_name: '',
      
      knottype_name: '',
      knottype_own: '',
      knot_power: '',
      
      embroiderypattern_name: '',
      embroiderypattern_own: '',
      embroidery_length: '',
      embroidery_yarn_name: '',
      embroidery_basic_yarn_name: ''
    });

    
    // useEffect zum Setzen des useState post (Daten) wird ausgefuehrt, wenn copiedData geaendert wird
    useEffect(() => {
      if (copiedData) {
        // Extrahieren des ersten Elements aus dem Unterarray `knit_contactingvariant`
        const contactingVariantData = copiedData.knit_contactingvariant?.[0] || {}; // Falls leer, setze leeres Objekt
    
        // kopierte Daten sowie die Daten aus `knit_contactingvariant` in den Zustand `post` setzen
        setPost(prevPost => ({
          ...prevPost,
          ...copiedData,
          ...contactingVariantData // Fuege die Unterarray-Daten hinzu
        }));
      }
    }, [copiedData]);


    // useEffect wird ausgefuehrt, wenn der institution_name im dropdown geaendert wird
    useEffect(() => {
      if (post.institution_name) {
        fetchMachineConfigurationOptions(post.institution_name); // Funktion zur Ausgabe der Maschinenkonfigurationen
        fetchYarnOptions(post.institution_name); // Funktion zur Ausgabe der Funktionsgarne
        fetchBasicYarnOptions(post.institution_name); // Funktion zur Ausgabe der Trägergarne
      }
    }, [post.institution_name]);


    // useEffect wird ausgefuehrt, wenn der contactingmethod_name geaendert wird, Felder werden neu gesetzt
    useEffect(() => {
      if (post.contactingmethod_name) {
        // Abrufen der Konfiguration für die ausgewaehlte Kontaktmethode
        const updatedFields = fieldConfigurations[post.contactingmethod_name] || [];
        // Setzen der Felder für die Kontaktmethode
        setFieldsContactingmethod(updatedFields);
      } else {
        // Falls keine Kontaktmethode ausgewaehlt ist, setzen auf leeres Array
        setFieldsContactingmethod([]);
      }
    }, [post.contactingmethod_name]);


    const handleInput = (event) => {
      const { name, value, type, checked } = event.target;
      // Update the post state with the selected value
      setPost(prevPost => ({
        ...prevPost,
        [name]: type === 'checkbox' ? checked : value,
      }));
  
      // Remove the error message once a valid selection is made
      if (errors[name]) {
        setErrors(prevErrors => ({
          ...prevErrors,
          [name]: null,
        }));
      }
    };
    
    const [errors, setErrors] = useState({});


    // Funktion zum Speichern eines neuen Kontaktierungsrezeptes
    const handleNewSave = async () => {
      let newErrors = {};

      try {
        // Schritt 1: Alle Felder auf Leerwert pruefen und Fehler sammeln
        fields.forEach((field) => {
          const value = String(post[field.name] || ''); // Standardwert auf leer setzen, falls undefined
          const rules = field.validate || {};
        
          // Validierung aufrufen und Fehler im neuen Fehlerobjekt speichern
          const error = validateField(field.name, value, rules, (errorObj) => {
            newErrors = { ...newErrors, ...errorObj };
          });
          
          if (error) {
            newErrors[field.name] = error;
          }
        });

        // Schritt 2: Zusätzliche Felder in `fieldConfigurations` validieren
        const selectedMethod = post.contactingmethod_name;
        if (fieldConfigurations[selectedMethod]) {
            fieldConfigurations[selectedMethod].forEach((field) => {
                const value = post[field.name] || ''; // Standardwert auf leer setzen, falls undefined
                const rules = field.validate || {};

                // Validierung aufrufen und Fehler im neuen Fehlerobjekt speichern
                const error = validateField(field.name, value, rules, (errorObj) => {
                    newErrors = { ...newErrors, ...errorObj };
                });

                if (error) {
                    newErrors[field.name] = error;
                }
            });
        }

        // Schritt 3: Fehler im Zustand speichern
        setErrors(newErrors);

        // Schritt 4: Ueberpruefen, ob Fehler vorhanden sind
        const hasErrors = Object.values(newErrors).some((error) => error !== '');

        if (hasErrors) {
          // Zeige das Modal, wenn noch Fehler vorhanden sind
          setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
          setShowErrorModal(true);
          return; // Stoppe das Speichern, bis die Fehler behoben sind
        }

        // Fehler zuruecksetzen, falls alles korrekt ist
        setErrors({});

        const timestamp = formatTimestampNow(); // Aktuellen Zeitstempel abrufen und formatieren
        const newPost = { ...post, id_institution, timestamp }; // Zeitstempel zum neuen Eintrag hinzufuegen

        // Setze leere Float- und Integer-Felder auf -123
        setDefaultForEmptyNumberFields(newPost, fields);
        // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
        convertCommaToDotForFloatFields(newPost, fields, fieldConfigurations);

        const response = await axios.post(`${url_root}/new_knit_contactingrecipe`, newPost,
          {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
          }
        );

        // Überprüfen des Statuscodes in der API-Antwort
        const statusCode = response.status;
        if (statusCode === 272) {
          setErrorMessage("Diese Bezeichnung für Kontaktierungsrezept ist schon vergeben.");
          setShowErrorModal(true);
          return; // Stoppt das Speichern, bis der Fehler behoben ist
        } else if (statusCode === 271) {
          setErrorMessage("Bitte geben Sie eine Bezeichnung ein.");
          setShowErrorModal(true);
          return;
        } else if (statusCode === 275) {
          setErrorMessage("Bitte geben Sie eine Kontaktierungsmethode ein.");
          setShowErrorModal(true);
          return;
        }
        
        const id_contactingrecipe = response.data.id_contactingrecipe

        // new_knit_contactingmethod mit neuer id_contacingrecipe + id_institution und newPost aufrufen
        // newPost um die neue id_contactingrecipe erweitern
        const newMethodPost = { ...newPost, id_contactingrecipe };

        await axios.post(`${url_root}/new_knit_contactingmethod`, newMethodPost,
          {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
          }
        );

        fetchContactingrecipeAll(); // Tabelle aktualisieren       
        /* Aufruf Funktion zur Weitergabe der id an die ContactingrecipePage, 
          danach an BasicTable, um den neuen Datensatz zu markieren */
        newSaveID(id_contactingrecipe); 
        closeNewPopup(); // Popup für neue Eintrage schließen
      } catch (error) {
        console.error('Fehler beim Speichern des neuen Eintrags:', error);
      }
    };
  

  return (
    <div className='new-popup-page'>
      <div className='new-title'>
          <h3>Hier können Sie ein neues Kontaktierungsrezept eingeben:</h3>
      </div>
      
      {/* Flexbox-Container für Felder */}
      <div className='new-fields-container'>

      {/* Gruppe 1: Vorherige Felder */}
      <div className='fields-group'>

      {id_role == 1 && (
        <div className="new-input-row">
          <label>Institution</label>
          <div className="new-input-with-unit">

            {/* bei Aenderung der Institution werden nur die Bereiche dieser Institution angezeigt */}
            <select 
              onChange={(e) => {
                // hier wird der ausgewaehlte institution_name des Dropdown-Menues in Variable gespeichert
                const selectedInstitution = e.target.value; 
                /* ...prevPost sorgt dafür, dass alle anderen Daten im post-Objekt erhalten bleiben 
                   und nur institution_name neu gesetzt wird */
                setPost(prevPost => ({
                  ...prevPost,  
                  /* institution_name wird geaendert, useEffect dadurch ausgelöst 
                     Aufruf: fetchMachineconfigurationOptions fetchBasicYarnOptions und fetchYarnOptions */
                  institution_name: selectedInstitution, 
                  // Setzt die Dropdown-Felder zurück, damit die alte Auswahl raus ist
                  machine_configuration_name: '',
                  yarn_name_1: '',
                  yarn_name_2: ''
                }));
              }} 
              name="institution_name" 
              value={post.institution_name}
              onFocus={(event) => handleFocus(event, setErrors)}
              // Manuelle Validierung fuer institution_name aufrufen
              onBlur={(e) => {const value = e.target.value;
                // Wenn das Feld leer ist, setze eine Fehlermeldung
                if (!value) {
                  setErrors(prevErrors => ({
                    ...prevErrors,
                    institution_name: "Bitte wählen Sie eine Institution."
                  }));
                } else {
                  // Entferne den Fehler, wenn eine Institution ausgewaehlt ist
                  setErrors(prevErrors => ({
                    ...prevErrors,
                    institution_name: ''
                }));
              }
            }}
            >
              <option value=""></option>
              {sortedInstitutionOptions.map((option, index) => (              
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {/* Fehlernachricht für institution_name anzeigen */}
            {errors.institution_name && (
              <span className="error-message">{errors.institution_name}</span>
            )}
          </div>
        </div>
      )}

      {fields.map(field => {
        const fieldValue = post[field.name];
        // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
        const displayValue = fieldValue < 0 ? '' : fieldValue;

        return (
        // Bedingung: Das Textfeld prediction nur anzeigen, wenn id_role == 1
        (field.name === 'prediction' && id_role > 1) ? null : (
          <div key={field.name} className="new-input-row">
            <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>
              <div className="new-input-with-unit">
                
              {/* nur bei NEU kann die Auswahl der Kontaktierungsmethode erfolgen, bei Aendern nicht */}
              {field.name === 'contactingmethod_name' ? (
              <>
                <select 
                  onChange={handleInput} 
                  name='contactingmethod_name' 
                  value={post.contactingmethod_name}
                  onFocus={(event) => handleFocus(event, setErrors)}
                  // Manuelle Validierung für institution_name aufrufen
                  onBlur={(e) => {const value = e.target.value;
                    // Wenn das Feld leer ist, setze eine Fehlermeldung
                    if (!value) {
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        contactingmethod_name: "Bitte wählen Sie eine Kontaktierungsmethode."
                      }));
                    } else {
                      // Entferne den Fehler, wenn eine Institution ausgewaehlt ist
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        contactingmethod_name: ''
                    }));
                  }
                }}
                >             
                  <option value=""></option>
                  {sortedContactingmethodOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                {/* Fehlernachricht für institution_name anzeigen */}
                {errors.contactingmethod_name && (
                  <span className="error-message">{errors.contactingmethod_name}</span>
                )}
              </>

              ) : field.type === 'select' ? (
                <>
                <select 
                  onChange={handleInput} 
                  name={field.name} 
                  value={displayValue}
                  onFocus={(event) => handleFocus(event, setErrors)}
                  onBlur={(event) => handleBlur(event, fields, fieldConfigurations, (name, value, rules) => 
                    validateField(name, value, rules, setErrors))}
                >
                  <option value=""></option>
                  {field.name === 'machine_configuration_name' && sortedMachineConfigurationOptions.length > 0 ? (
                    sortedMachineConfigurationOptions.map((option, index) => (              
                      <option key={index} value={option}>
                        {option}
                      </option>
                  ))
                  ) : field.name === 'basic_yarn_name' && sortedBasicYarnOptions.length > 0 ? (
                    sortedBasicYarnOptions.map((option, index) => (              
                      <option key={index} value={option}>
                        {option}
                      </option>
                  ))
                  ) : field.name === 'yarn_1_name' && sortedYarnOptions.length > 0 ? (
                    sortedYarnOptions.map((option, index) => (              
                      <option key={index} value={option}>
                        {option}
                      </option>
                  ))
                  ) : field.name === 'yarn_2_name' && sortedYarnOptions.length > 0 ? (
                    sortedYarnOptions.map((option, index) => (              
                      <option key={index} value={option}>
                        {option}
                      </option>
                  ))
                  ) : null}
                </select>
                  {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
                  {errors[field.name] && (
                    <span className="error-message">{errors[field.name]}</span>
                  )}
                </>

                ) : field.type === 'checkbox' ? (
                  <div className="new-input-row-checkbox">
                    <input 
                      type="checkbox"
                      name={field.name}
                      checked={post[field.name]}
                      onChange={handleInput}
                    />
                  </div>
                ) : field.type === 'textarea' ? (
                  <textarea className='textarea'
                    name={field.name}
                    value={displayValue}
                    onChange={handleInput}
                  />
              ) : (
              <>
                <input
                  type={field.type} 
                  name={field.name} 
                  value={displayValue} 
                  onChange={handleInput} 
                  
                  onFocus={(event) => handleFocus(event, setErrors)}
                  onBlur={(event) => handleBlur(event, fields, fieldConfigurations, (name, value, rules) => 
                    validateField(name, value, rules, setErrors))}

                  // Vorhersage-Feld wird ausgegraut (transparent)
                  className={`${field.name === 'prediction' ? 'prediction-field' : ''
                    } ${errors[field.name] ? 'input-error' : ''}`.trim()}
                
                  readOnly={field.name === 'prediction'}
                />
                {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}     
              </>
                )}
              </div>
            </div>
          
        ));
      })}

      <div className='new-input-save-cancel'>
        <button onClick={() => closeNewPopup()}>ABBRECHEN</button> 
        <button onClick={() => handleNewSave()}>SPEICHERN</button>       
      </div>
    </div> {/* Ende Gruppe 1 */}

      {/* Gruppe 2 Dynamische Eingabefelder für Kontaktierungsmethoden */}
      <div className='fields-group new-fields-contactingmethod'>
        {fieldsContactingmethod.map(field => {
          const fieldValue = post[field.name];
          // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
          const displayValue = fieldValue < 0 ? '' : fieldValue;

        return (
          <div key={field.name} className="new-input-row">
            <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>

              <div className="new-input-with-unit">
                {field.type === 'select' ? (
                  <>
                  <select onChange={handleInput} name={field.name} value={displayValue}>
                    <option value=""></option>
                    {field.name === 'glue_name' && sortedGlueOptions.length > 0 ? (
                      sortedGlueOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                    ))
                    ) : field.name === 'soldering_agent_name' && sortedSolderingagentOptions.length > 0 ? (
                      sortedSolderingagentOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                    ))
                    ) : field.name === 'flux_name' && sortedFluxOptions.length > 0 ? (
                      sortedFluxOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                    ))
                    ) : field.name === 'crimpshape_name' && sortedCrimpshapeOptions.length > 0 ? (
                      sortedCrimpshapeOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                    ))
                    ) : field.name === 'knottype_name' && sortedKnottypeOptions.length > 0 ? (
                      sortedKnottypeOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                    ))
                    ) : field.name === 'embroiderypattern_name' && sortedEmbroiderypatternOptions.length > 0 ? (
                      sortedEmbroiderypatternOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                    ))
                    ) : field.name === 'embroidery_yarn_name' && sortedYarnOptions.length > 0 ? (
                      sortedYarnOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                    ))
                    ) : null}
                  </select>
                  {errors[field.name] && <span className="error-message">{errors[field.name]}</span>} 
                  </>
                    ) : field.type === 'checkbox' ? (
                      <div className="new-input-row-checkbox">
                        <input 
                          type="checkbox"
                          name={field.name}
                          checked={post[field.name]}
                          onChange={handleInput}
                        />
                      </div>
                    ) : (
                <>
                  <div className="new-input-with-fixed-unit">
                    <input
                      type={field.type}
                      value={displayValue}
                      onChange={handleInput}
                      name={field.name}

                      onFocus={(event) => handleFocus(event, setErrors)}
                      onBlur={(event) => handleBlur(event, fields, fieldConfigurations, (name, value, rules) => 
                        validateField(name, value, rules, setErrors))}

                      // Verkettung der bestehenden Klassen mit der Fehlerklasse
                      className={`${field.unit_fix ? 'input-with-unit-fix' : ''} ${errors[field.name] ? 'input-error' : ''}`}                

                      autoComplete="off" // Hilft den Fokus nicht zu vergessen
                    />
                    {field.unit_fix && <span className="new-unit-label">{field.unit_fix}</span>}
                    {errors[field.name] && <span className="error-message">{errors[field.name]}</span>} 
                  </div>

                    {field.unit && (  // rendern nur, wenn field.unit einen Wert hat                    
                      <div> 
                      <select // dropdown-Menu wird gerendert, wenn ein unit (Masseinheit) vorhanden ist
                        className="unit-dropdown"
                        name={field.unit} // Verwenden Sie field.unit direkt als name
                        value={post[field.unit]} // Verwenden Sie field.unit direkt, um den Wert aus post zu erhalten
                        onChange={handleInput} // Uebergeben Sie Ihre handleInput-Funktion für onChange                 
                      >

                        <option value="" disabled> </option>
                        
                        {field.unit === 'unit_glue_temperature_name' && sortedGlueTemperatureUnitOptions.length > 0 ? (
                          sortedGlueTemperatureUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_solder_temperature_name' && sortedSolderTemperatureUnitOptions.length > 0 ? (
                          sortedSolderTemperatureUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        )  : null}
                      </select>
                      
                      {field.unit === 'unit_glue_temperature_name' && errors.unit_glue_temperature_name && (
                        <span className="error-message">{errors.unit_glue_temperature_name}</span>)}
                      
                      {field.unit === 'unit_solder_temperature_name' && errors.unit_solder_temperature_name && (
                        <span className="error-message">{errors.unit_solder_temperature_name}</span>)}
                      </div>     
                    )}
                  </>
                )}
              </div>
            </div>
            );
          })}
      </div> {/* Ende Dynamische Eingabefelder für Kontaktierungsmethoden */}
    </div> {/* Ende Flexbox-Container */}
  </div>
  )
}

export default ContactingrecipeNew
